import { SERVER_URL } from "../../api";
import axios from 'axios'
import { getHeaderWithToken } from "../../helpers/func";
export const DELETE_COLOR_REQUEST = 'DELETE_COLOR_REQUEST';
export const DELETE_COLOR_SUCCESS = 'DELETE_COLOR_SUCCESS';
export const DELETE_COLOR_ERROR = 'DELETE_COLOR_ERROR';
export const RESET_DELETE_COLOR = 'RESET_DELETE_COLOR';


export const deleteColor = (id, data) => {

    let headers = getHeaderWithToken();
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: DELETE_COLOR_REQUEST
            })
            axios({
                method: 'DELETE',
                url: `${SERVER_URL}v1/pattern/color`,
                headers: headers,
                data: { id, data }
            }).then(function (response) {
                dispatch({
                    type: DELETE_COLOR_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: DELETE_COLOR_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}



